<template>
  <div>
    <v-flex xs12>
      <v-autocomplete
        v-model="internalCustomer"
        :items="autocomplete.entries"
        :loading="autocomplete.isLoading"
        :search-input.sync="autocomplete.search"
        color="black"
        hide-no-data
        hide-selected
        item-text="name"
        item-value="name"
        :label="$vuetify.t('$vuetify.lobis.selectCustomer')"
        :placeholder="$vuetify.t('$vuetify.lobis.queryCustomer')"
        prepend-icon="mdi-database-search"
        return-object
        no-filter
      ></v-autocomplete>
    </v-flex>
    <v-flex xs12>
      <v-autocomplete
        v-if="internalCustomer && internalCustomer.projects && internalCustomer.projects.length"
        v-model="internalProject"
        :items="internalCustomer.projects"
        color="black"
        hide-no-data
        hide-selected
        item-text="name"
        item-value="id"
        :label="$vuetify.t('$vuetify.lobis.selectProject')"
        :placeholder="$vuetify.t('$vuetify.lobis.queryProject')"
        prepend-icon="mdi-database-search"
        return-object
      >
      </v-autocomplete>
    </v-flex>
    <v-card v-if="internalProject && internalProject.note">
      <p>{{ internalProject.note }}</p>
    </v-card>
  </div>
</template>

<script>
import apiCall from '../../utils/api'

export default {
  props: {
    customer: {
      type: Object
    },
    project: {
      type: Object
    }
  },
  data () {
    return {
      autocomplete: {
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        search: null
      }
    }
  },
  computed: {
    internalCustomer: {
      get () {
        return this.customer
      },
      set (value) {
        this.$emit('update:customer', value)
      }
    },
    internalProject: {
      get () {
        return this.project
      },
      set (value) {
        this.$emit('update:project', value)
      }
    }
  },
  created () {
    this.autocomplete.entries = [...this.autocomplete.entries, this.customer]
  },
  watch: {
    'autocomplete.search' (val) {
      // Items have already been requested
      if (this.autocomplete.isLoading) return

      this.autocomplete.isLoading = true

      // Lazily load input items
      apiCall({ url: 'api/customers', method: 'POST', q: val }).then(resp => {
        this.autocomplete.entries = resp
      }).catch(err => {
        console.log(err)
      }).finally(() => (this.autocomplete.isLoading = false))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Formcomponents/CustomerSelect.vue